import * as yup from 'yup';

export type CreateBusinessUnitFormValues = {
  name: string;
};

export const createBusinessUnitSchema = yup
  .object({
    name: yup.string().trim().label('Name').required()
  })
  .required();

export type RenameBusinessUnitFormValues = {
  name: string;
};

export const renameBusinessUnitSchema = yup
  .object({
    name: yup.string().trim().label('Name').required()
  })
  .required();
